/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-25 16:19:59
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2018-01-23 15:10:11
 */
//权限-角色管理页面
<template>
  <div class="role-wrap">
    <div class="header-wrap">
      <title-btn  title="角色管理" btnTitle="+ 添加角色" v-on:click="showPreBox"/>
    </div>
    <div class="content-wrap">
      <div class="content-list" v-for="(item,index) in roleList" :key="index">
        <div class="account-wrap">
          <span class="roleId" v-text="item.roleId"></span>
          <span class="account" v-text="item.roleName"></span>
        </div>
        <div class="name-wrap">
          <div class="name-title-wrap">
            <span class="name-title">权限分配:</span>
          </div>
          <div class="pre-wrap">
            <span class="name"  v-for="pre in item.newMenu" :key="pre.id" v-text="pre.name"></span>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info">
            <span class="name-title">用户量(人)</span>
            <span class="name" v-text="item.totalPeople"></span>
          </div>
        </div>
        <div class="button-wrap">
          <div class="btn">
           <el-button type="text" @click="showPreBox('修改角色',item,true)" style="color: #aaa;">修改</el-button>
          </div>
          <div class="btn">
           <el-button @click="deleteRole(item.totalPeople,item.roleId)" type="text" style="color: #f03745;">删除</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 页码 -->
    <div class="pageWrap">
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="count"
        @current-change="clickPage"
        >
      </el-pagination>
    </div>
    <!-- 添加/修改角色 -->
    <user-pre :visible="isShowPre"
      :data="data"
      :title="preBoxTitle"
      :showForm="isShowForm"
      :roleInfo="roleInfo"
      :defaultChecked="defaultChecked"
      v-on:cancel="isShowPre = false"
      v-on:noClosed="isShowEdit = true"
      v-on:sure="surePre($event)"/>
  </div>
</template>

<script>
import TitleBtn from "@/components/TitleButton";
import UserPre from "./UserPer";
import { getCookie } from "@/utils/common";
import { toTreeData } from "./toTreeData";
import {
  addRole,
  getRoleList,
  deleteRole,
  getPremiss
} from "@/api/permission/roleManage";
export default {
  name: "roleManage",
  components: {
    TitleBtn,
    UserPre
  },
  data() {
    return {
      isShowPre: false,
      isShowForm: true,
      isEdit: false,
      duration: 1000,
      preBoxTitle: "添加角色",
      currentPage: 1,
      pageSize: 10,
      count: 0,
      data: [],
      roleInfo: {},
      listRole: [],
      defaultChecked: [1]
    };
  },
  created() {
    this._getRoleList();
  },
  computed: {
    roleList() {
      let roleList = this.listRole;
      let len = this.listRole.length;
      for (let i = 0; i < len; i++) {
        let { listFirstMenu, listsecondMenu, listThreeMenu } = roleList[
          i
        ].roleMent;
        let newMenu = [...listFirstMenu]; //, ...listsecondMenu, ...listThreeMenu
        roleList[i]["newMenu"] = newMenu;
      }
      return roleList;
    }
  },
  methods: {
    showPreBox(title = "添加角色", roleInfo = {}, isEdit = false) {
      this.preBoxTitle = title;
      this.isEdit = isEdit;
      if (
        !getCookie("listFirstMenu") &&
        !getCookie("listsecondMenu") &&
        !getCookie("listThreeMenu")
      ) {
        return;
      } else {
        const listFirstMenu = JSON.parse(getCookie("listFirstMenu"));
        const listSecondMenu = JSON.parse(getCookie("listsecondMenu"));
        const listThreeMenu = JSON.parse(getCookie("listThreeMenu"));
        const data = [...listFirstMenu, ...listSecondMenu, ...listThreeMenu];
        this.data = toTreeData(data);
      }
      if (isEdit) {
        this.roleInfo = roleInfo;
        this.roleId = roleInfo.roleId;
        this._getPremiss();
      } else {
        this.roleInfo = {};
        this.defaultChecked = [1];
      }
      this.isShowPre = true;
    },
    deleteRole(total, id) {
      if (total > 0) {
        this.$message({
          message: "该角色目前还有人员使用暂不可删除!",
          type: "warning"
        });
        return;
      }
      this.$confirm("是否删除此角色", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteRole(id)
            .then(res => {
              if ("success" === res.data.msg) {
                this._getRoleList();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                  duration: this.duration
                });
              }
            })
            .catch(error => {
              let msg = "请求出错！";
              if (error.response.data) {
                msg = error.response.data.msg || "请求出错";
              }

              this.$message({
                type: "warning",
                message: msg,
                duration: this.duration
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            duration: this.duration
          });
        });
    },
    // 添加编辑角色
    surePre(data) {
      addRole(data, this.isEdit)
        .then(res => {
          if ("success" === res.data.msg) {
            let msg = "添加角色成功";
            if (this.isEdit) {
              msg = "编辑成功!";
            } else {
              this.currentPage = 1;
            }
            this._notify(msg);
            this._getRoleList();
            this.isShowPre = false;
          }
        })
        .catch(error => {
            // this.$message({
            //   type:"error",
            //   message:"抱歉，您没有当前模块的访问权限"
            // })
          //this._notify("请求出错,请重试", "warning");
        });
    },
    // 点击页码
    clickPage(val) {
      this.currentPage = val;
      this._getRoleList();
    },
    // 获取角色对应菜单
    _getPremiss() {
      getPremiss(this.roleId)
        .then(res => {
          const { listFirstMenu, listsecondMenu, listThreeMenu } = res.data;
          const data = [...listsecondMenu, ...listThreeMenu];
          let len = data.length;
          let checkIds = [],
            firstIds = [],
            secondIds = [],
            threeIds = [];
          let tLen = listThreeMenu.length,
            fLen = listFirstMenu.length,
            sLen = listsecondMenu.length;
          for (let f = 0; f < fLen; f++) {
            firstIds.push(listFirstMenu[f].id);
          }
          firstIds = [...new Set(firstIds)];
          for (let s = 0; s < sLen; s++) {
            let pId = listsecondMenu[s].parentId;
            let idx = firstIds.indexOf(pId);
            if(-1 != idx) {
              firstIds[idx] = 0;
            }
            secondIds.push(listsecondMenu[s].id);
          }
          secondIds = [...new Set(secondIds)];
          for (let t = 0; t < tLen; t++) {
            let pId = listThreeMenu[t].parentId;
            threeIds.push(listThreeMenu[t].id);
            let idx = secondIds.indexOf(pId);
            if (-1 != idx) {
              secondIds[idx] = 0;
            }
          }
          checkIds = checkIds.concat(firstIds,secondIds, threeIds);
          checkIds.push(1);
          this.defaultChecked = checkIds;
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    // 获取角色列表
    _getRoleList() {
      getRoleList(this.currentPage, this.pageSize)
        .then(res => {
          console.log(res);
          if (res.data.listRole.length != 0) {
            for (let prop in res.data) {
              this[prop] = res.data[prop];
            }
          }
        })
        .catch(error => {
            // this.$message({
            //   type:"error",
            //   message:"抱歉，您没有当前模块的访问权限"
            // })
          //this._notify("请求出错,请重试", "warning");
        });
    },
    //通知框
    _notify(message = "提示", type = "success") {
      this.$notify({
        title: "提示",
        message,
        type,
        duration: 3000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.role-wrap {
  width: 97%;
  min-height: 100%;
  background-color: #ecf0f0;
  margin: 20px 0;
  padding: 0 20px;

}
.content-wrap {
  /*margin: 20px 0;*/
  /*padding: 0 20px;*/
}
.content-list {
  $width: 20%;
  %_center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  %_com {
    width: $width;
    @extend %_center;
  }
  width: 100%;
  height: 120px;
  display: flex;
  font-size: 16px;
  margin-bottom: 10px;
  justify-content: flex-start;
  border-radius: 10px;
  background-color: #fff;
  .name-title {
    color: #777;
  }
  .name {
    color: #333;
  }
  .account-wrap {
    @extend %_com;
    justify-content: flex-start;
    .roleId {
      direction: inline-block;
      padding: 0 20px;
    }
    .account {
      color: #666;
    }
  }
  .name-wrap {
    @extend %_center;
    justify-content: flex-start;
    flex: 1;
    .name-title-wrap {
      @extend %_com;
      height: 100%;
    }
    .pre-wrap {
      // flex: 1;
      width: 369px;
      height: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 20px 5px;
      flex-wrap: wrap;
      > .name {
        border-right: 1px solid #ddd;
        display: inline-block;
        font-size: 14px;
        height: 20px;
        width: 80px;
        padding: 0 5px;
        text-align: center;
        line-height: 20px;
        color: #7d8893;
        &:nth-child(3n + 1) {
          border-left: 1px solid #ddd;
        }
      }
    }
  }
  .info-wrap {
    @extend %_com;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px 0;
    border-right: 1px solid #ddd;
    .info {
      > span {
        display: inline-block;
        margin: 0 5px;
      }
    }
  }
  .button-wrap {
    width: 20%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    .btn {
      flex: 1;
      @extend %_center;
      .el-button {
        padding: 8px 20px;
      }
    }
  }
}
.pageWrap {
  margin-top: 20px;
  padding-bottom: 10px;
  .el-pagination {
    text-align: center;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/permissions/RoleManage.vue